<template>
  <div class="fastbt_link">
    <div class="marb_10  org_bk_fl">
      <a :href="memberUrl" class="ob_imc">
        <span></span>
      </a>
    </div>
    <div class="marb_10  org_color">
      <template v-for="data in orangeData">
        <a target="_blank" :href="data.Link" :class="data.Class"><span></span><p v-text="data.Name"></p></a>
      </template>
    </div>
    <div class="wwbk marb_10 green">
      <template v-for="data in greenData">
        <a target="_blank" :href="data.Link" :class="data.Class"><span></span><p v-text="data.Name"></p></a>
      </template>
    </div>
    <div class="wwbk marb_10 gray">
      <template v-for="data in noneData">
        <a target="_blank" :href="data.Link" :class="data.Class"><span></span><p v-text="data.Name"></p></a>
      </template>
    </div>
    <div class="gotop">
      <i class="fas fa-arrow-up"></i>
      <button type="button" v-on:click="goTop"></button>
    </div>
  </div>
</template>

<script>
    import Constants from "../Constants";
    import utils from "../Utils";
    import _ from "lodash";
    export default {
        name: "FastLink",
        props: {
        },
        mixins: [utils],
        data() {
            return {
              url:`${Constants.serverUrl}/api/slide-link`,
              slideLinkList: [],
              memberUrl: ''
            };
        },
        created() {
        },
        mounted() {
          const _this = this
          _this.fetchData(this.url, '', 'slideLinkList','pageData.contentData', function (extraParams, response) {
            _this.slideLinkList = _.get(response, 'data.Value.pageData.contentData.slideLinkList', [])
            _this.memberUrl     = _.get(response, 'data.Value.pageData.contentData.memberUrl', '')
          })
        },
        methods: {
        },
        computed: {
          orangeData() {
            return _.filter(this.slideLinkList , function (o) {
              return o.GroupName === 'org_color';
            });
          },
          greenData() {
            return _.filter(this.slideLinkList, function (o) {
              return o.GroupName === 'green';
            });
          },
          noneData() {
            return _.filter(this.slideLinkList, function (o) {
              return o.GroupName === '';
            });
          },
        },
    };
</script>
